export enum RapprochementAvoirExterneStatutEnum {
  NON_RAPPROCHE = 'NON_RAPPROCHE',
  RAPPROCHEMENT_OK = 'RAPPROCHEMENT_OK',
  ECART = 'ECART',
  ECART_VALIDE = 'ECART_VALIDE',
  BL_MANQUANT = 'BL_MANQUANT',
  FOURNISSEUR_INTROUVABLE = 'FOURNISSEUR_INTROUVABLE'
}

export const RAPPROCHEMENT_AVOIR_EXTERNE_STATUT_LABELS: Record<RapprochementAvoirExterneStatutEnum, string> = {
  [RapprochementAvoirExterneStatutEnum.NON_RAPPROCHE]:          'Non rapproché',
  [RapprochementAvoirExterneStatutEnum.RAPPROCHEMENT_OK]:       'Rapprochement OK',
  [RapprochementAvoirExterneStatutEnum.ECART]:                  'Écart',
  [RapprochementAvoirExterneStatutEnum.ECART_VALIDE]:           'Écart validé',
  [RapprochementAvoirExterneStatutEnum.BL_MANQUANT]:            'BL manquant',
  [RapprochementAvoirExterneStatutEnum.FOURNISSEUR_INTROUVABLE]:'Fournisseur introuvable',
};
